<p-confirmDialog />
<div class="border-top-1 border-300 flex" style="min-height: 0; height: 100%; overflow: hidden;">
  <p-menu [model]="items" styleClass="h-full border-top-none" [style]="{ 'overflow-y': 'auto'}" />
  <div class="flex-1" style="min-width: 0; overflow-y: auto;">
    <ng-container *emPermission="Permission.CONFIG_STAFFING">
      <em-technology *ngIf="activeItem == 'technologies'" />
      <em-skill-category *ngIf="activeItem == 'skill-categories'" />
      <em-sector *ngIf="activeItem == 'sectors'" />
      <em-nearshore *ngIf="activeItem == 'nearshores'" />
      <em-cluster *ngIf="activeItem == 'clusters'" />
      <em-offshore-level *ngIf="activeItem == 'offshore-levels'" />
    </ng-container>
    <ng-container *emPermission="Permission.CONFIG_BSA">
      <em-practices *ngIf="activeItem == 'practices-page'" />
      <em-career-path *ngIf="activeItem == 'career-paths-page'" />
      <em-category *ngIf="activeItem == 'categories'" />
      <em-country *ngIf="activeItem == 'countries'" />
      <em-region *ngIf="activeItem == 'regions'" />
      <em-status *ngIf="activeItem == 'statuses'" />
      <em-runtime-settings *ngIf="activeItem == 'runtime-settings'" />
      <em-document-template *ngIf="activeItem == 'document-templates'" />
    </ng-container>
    <ng-container *emPermission="Permission.CONFIG_INVOICING">
      <em-staffed-role *ngIf="activeItem == 'staffed-roles'" />
      <em-currency *ngIf="activeItem == 'currency'" />
      <em-working-hours *ngIf="activeItem == 'working-hours'" />
      <em-guard-configuration *ngIf="activeItem == 'guard-configuration'" />
      <em-jira-project-key *ngIf="activeItem == 'jira-project-keys'"></em-jira-project-key>
      <em-invoicing-project-account *ngIf="activeItem == 'invoicing-project-accounts'"></em-invoicing-project-account>
      <em-invoicing-settings *ngIf="activeItem == 'invoicing-settings'"></em-invoicing-settings>
      <em-training-batch-settings *ngIf="activeItem == 'training-batch'"></em-training-batch-settings>
      <em-currency-exchange *ngIf="activeItem == 'currency-exchange'"/>
    </ng-container>
    <ng-container *ngIf="canManageEvaluation">
      <em-evaluation *ngIf="activeItem == 'evaluation'"></em-evaluation>
    </ng-container>
    <ng-container *emPermission="Permission.CONFIG_PERFORMANCE">
      <em-opportunity-reference-data *ngIf="activeItem == 'opportunities'"></em-opportunity-reference-data>
    </ng-container>
    <ng-container *ngIf="canManagePool">
      <em-pool *ngIf="activeItem == 'pool'"></em-pool>
    </ng-container>
    <ng-container *emPermission="Permission.CONFIG_USER_MANAGEMENT">
      <em-role-mgmt *ngIf="activeItem == 'permissions'" [selectedRole]="selectedRole"></em-role-mgmt>
      <em-role-users *ngIf="activeItem == 'users'"></em-role-users>
      <em-roles *ngIf="activeItem == 'roles'" (roleSelected)="onRoleSelected($event)"></em-roles>
    </ng-container>
  </div>
</div>
